import React from "react";

const CreateNewLeagueContext = React.createContext();

function createNewLeagueReducer(state, action) {
  switch (action.type) {
    case "setGameList": {
      return {
        ...state,
        gameList: action.value,
      };
    }
    case "setSelectedGame": {
      return {
        ...state,
        gameType: action.value.gameType,
        gameRule: action.value.gameRule,
        scoreRule: action.value.scoreRule,
        gameTypeId: action.value.id,
      };
    }
    case "setSelectedLeague": {
      return {
        ...state,
        selectedLeague: action.value,
      };
    }
    case "setGameType": {
      return {
        ...state,
        gameType: action.value,
      };
    }
    case "setGameRule": {
      if (action.value == null) {
        return {
          ...state,
          gameRule: action.value,
          gameRules: [],
        };
      }
      return {
        ...state,
        gameRule: action.value,
      };
    }
    case "setScoreRule": {
      if (action.value == null) {
        return {
          ...state,
          scoreRule: action.value,
          scoreRules: [],
        };
      }
      return {
        ...state,
        scoreRule: action.value,
      };
    }
    case "setGameTypes": {
      return {
        ...state,
        gameTypes: action.value,
      };
    }
    case "setGameRules": {
      return {
        ...state,
        gameRules: action.value,
      };
    }
    case "setScoreRules": {
      return {
        ...state,
        scoreRules: action.value,
      };
    }
    case "setGameLeagues": {
      return {
        ...state,
        gameLeagues: action.value,
      };
    }
    case "setLeagueRounds": {
      return {
        ...state,
        leagueRounds: action.value,
      };
    }
    case "setEliminationRate": {
      return {
        ...state,
        eliminationRate: action.value,
      };
    }
    case "setMinimumCorrectRate": {
      return {
        ...state,
        minimumCorrectRate: action.value,
      };
    }
    case "setBoosts": {
      return {
        ...state,
        boosts: action.value,
      };
    }
    case "setAllWinBonus": {
      return {
        ...state,
        allWinBonus: action.value,
      };
    }
    case "setStake": {
      return {
        ...state,
        stake: action.value,
      };
    }
    case "setCorrectScorePointsFull": {
      return {
        ...state,
        correctScorePointsFull: action.value,
      };
    }
    case "setCorrectScorePointsPartial": {
      return {
        ...state,
        correctScorePointsPartial: action.value,
      };
    }
    case "setLeagueImage": {
      return {
        ...state,
        leagueImage: action.value,
      };
    }
    case "setLeagueIcon": {
      return {
        ...state,
        leagueIcon: action.value,
      };
    }
    case "setImageList": {
      return {
        ...state,
        imageList: action.value,
      };
    }
    case "setIconList": {
      return {
        ...state,
        iconList: action.value,
      };
    }
    case "setVisibility": {
      return {
        ...state,
        visibility: action.value,
      };
    }
    case "setLeagueName": {
      return {
        ...state,
        leagueName: action.value,
      };
    }
    case "setStartRound": {
      if (action.value == null) {
        return {
          ...state,
          startRound: action.value,
          includedRounds: [],
          deadline: null,
          endingAt: null,
        };
      }
      let includedRounds = [];
      let startRound = state?.leagueRounds?.find(
        (league) => league.id == action.value
      );
      if (state.gameType == 1) {
        state?.leagueRounds?.forEach((league) => {
          if (league.startTime > startRound.startTime) {
            includedRounds.push(league.id);
          }
        });
      }

      return {
        ...state,
        startRound: action.value,
        includedRounds: [action.value, ...includedRounds],
        deadline: startRound?.startTime,
        endingAt: startRound?.endTime,
      };
    }
    case "setLeagueRoundLength": {
      if (action.value == null) {
        return {
          ...state,
          includedRounds: [],
          endingAt: undefined,
        };
      }
      const start = state?.leagueRounds?.find(
        (league) => league.id == state.startRound
      );

      const startTime = start?.startTime;
      let includedRoundsArray = [];

      if (state.gameType == 0) {
        state?.leagueRounds?.forEach((league) => {
          if (league.startTime >= startTime) {
            includedRoundsArray.push(league.id);
          }
        });
      }
      includedRoundsArray = includedRoundsArray.slice(0, Number(action.value));

      const lastElement = includedRoundsArray.slice(-1);

      const elem = state?.leagueRounds?.find(
        (league) => league.id == lastElement
      );

      const endTime = elem?.endTime;

      return {
        ...state,
        includedRounds: includedRoundsArray,
        endingAt: endTime,
      };
    }
    case "setStartingBalanceFactorRound": {
      return {
        ...state,
        startingBalanceFactor: action.value,
      };
    }
    case "setStartingBalanceFactorLeague": {
      return {
        ...state,
        startingBalanceFactor: action.value,
      };
    }
    case "createTournament": {
      return {
        ...state,
        createdTournamentId: action.value,
      };
    }
    case "resetContext": {
      return {
        selectedGame: null,
        gameList: [],
        selectedLeague: null,
        gameType: null,
        gameRule: null,
        scoreRule: null,
        gameTypeId: null,
        gameTypes: [],
        gameRules: [],
        scoreRules: [],
        gameLeagues: [],
        leagueRounds: [],
        includedRounds: [],
        startRound: null,
        deadline: null,
        endingAt: null,
        startingBalanceFactor: null,
        eliminationRate: null,
        minimumCorrectRate: null,
        boosts: null,
        allWinBonus: null,
        correctScorePointsFull: null,
        correctScorePointsPartial: null,
        stake: null,
        leagueImage: null,
        leagueIcon: null,
        imageList: [],
        iconList: [],
        visibility: false,
        leagueName: "",
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function CreateNewLeagueProvider({ children }) {
  const [state, dispatch] = React.useReducer(createNewLeagueReducer, {
    selectedGame: null,
    gameList: [],
    selectedLeague: null,
    gameType: null,
    gameRule: null,
    scoreRule: null,
    gameTypeId: null,
    gameTypes: [],
    gameRules: [],
    scoreRules: [],
    gameLeagues: [],
    leagueRounds: [],
    includedRounds: [],
    startRound: null,
    deadline: null,
    endingAt: null,
    startingBalanceFactor: null,
    eliminationRate: null,
    minimumCorrectRate: null,
    boosts: null,
    allWinBonus: null,
    correctScorePointsFull: null,
    correctScorePointsPartial: null,
    stake: null,
    leagueImage: null,
    leagueIcon: null,
    imageList: [],
    iconList: [],
    visibility: false,
    leagueName: "",
    createdTournamentId: null,
  });

  const value = { state, dispatch };
  return (
    <CreateNewLeagueContext.Provider value={value}>
      {children}
    </CreateNewLeagueContext.Provider>
  );
}

function useCreateNewLeague() {
  const context = React.useContext(CreateNewLeagueContext);

  if (context === undefined) {
    throw new Error("useNewLeague must be used within a EventProvider");
  }
  return context;
}

export { CreateNewLeagueProvider, useCreateNewLeague };
